module.exports = __webpack_public_path__ + "static/img/organisation_ico.c1ff4090.png";